import { gql } from '@apollo/client';

const LEAD_SOURCE_LIST_FIELDS = `
    _id
    sources {
        key
        label
    }
`;

export const CREATE_CRM_LEAD_SOURCE = gql`
    mutation CreateCrmLeadSource($input: CreateCrmLeadSourceInput!) {
        createCrmLeadSource(input: $input) {
            ${LEAD_SOURCE_LIST_FIELDS}
        }
    }
`;

export const RENAME_CRM_LEAD_SOURCE = gql`
    mutation RenameCrmLeadSource($input: RenameCrmLeadSourceInput!) {
        renameCrmLeadSource(input: $input) {
            ${LEAD_SOURCE_LIST_FIELDS}
        }
    }
`;

export const DELETE_CRM_LEAD_SOURCE = gql`
    mutation DeleteCrmLeadSource($input: DeleteCrmLeadSourceInput!) {
        deleteCrmLeadSource(input: $input) {
            ${LEAD_SOURCE_LIST_FIELDS}
        }
    }
`;
